import type {
  PendingPermissionGroupInvite,
  PendingPermissionInvite,
} from '@affine/core/modules/permissions/views/permission-create-modal-core';

import {
  type FolderCreatePermissionVariant,
  type FolderPermissionVisibility,
  getDefaultFolderCreateSettings,
} from './folder-permission-policy';

export interface FolderCreateConfig {
  name: string;
  visibility: FolderPermissionVisibility;
  inheritPermissions: boolean;
  pendingInvites: PendingPermissionInvite[];
  pendingGroupInvites: PendingPermissionGroupInvite[];
}

export const createDefaultFolderCreateConfig = (
  variant: FolderCreatePermissionVariant,
  name: string
): FolderCreateConfig => ({
  ...getDefaultFolderCreateSettings(variant),
  name,
  pendingGroupInvites: [],
  pendingInvites: [],
});
